/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { all, takeLatest } from 'redux-saga/effects'

import * as acts from '../actions'
import * as fastquote from './fastquote.saga'
import * as product from './product.saga'
import * as startup from './startup.saga'

export default function* root() {
  yield all([
    /**
     * What does takeLatest do?
     *    call the 'startup()' saga when a 'STARTUP' action is triggered
     *    takeLatest(acts.startup_types.STARTUP, startup)
     */

    // Startup sagas
    takeLatest(acts.startup_types.SAGA_STARTUP, startup.saga_startup),

    // Data sagas
    takeLatest(acts.data_types.SAGA_RESOLVE_FPOOL_GENERAL, product.saga_resolve_fpool_general),
    takeLatest(acts.data_types.SAGA_RESOLVE_FPOOL_SPECIAL, product.saga_resolve_fpool_special),
    takeLatest(
      acts.data_types.SAGA_RESOLVE_FPOOL_FASTQUOTE,
      fastquote.saga_resolve_fpool_fastquote
    ),
    takeLatest(acts.data_types.SAGA_RESOLVE_PRODUCTS, product.saga_resolve_products),
    takeLatest(acts.data_types.SAGA_RESOLVE_VEHICLE_BRANDS, product.saga_resolve_vehicle_brands),
    takeLatest(acts.data_types.SAGA_RESOLVE_VEHICLE_MODELS, product.saga_resolve_vehicle_models),
    takeLatest(
      acts.data_types.SAGA_RESOLVE_VEHICLE_VERSIONS,
      product.saga_resolve_vehicle_versions
    ),
    takeLatest(
      acts.data_types.SAGA_RESOLVE_RESIDENCE_MUNICIPALITIES,
      product.saga_resolve_residence_municipalities
    ),
    takeLatest(acts.data_types.SAGA_RESOLVE_AGENCIES, product.saga_resolve_agencies),
    takeLatest(acts.data_types.SAGA_REQUIRE_QUOTE, product.saga_require_quote),
    takeLatest(acts.data_types.SAGA_RESOLVE_QUOTEDOC, product.saga_resolve_quotedoc),
    takeLatest(acts.data_types.SAGA_RESOLVE_OTHERDOCS, product.saga_resolve_otherdocs),
    takeLatest(acts.data_types.SAGA_RESOLVE_OTHERDOC, product.saga_resolve_otherdoc),
    takeLatest(acts.data_types.SAGA_RESOLVE_PARAMETERS, product.saga_resolve_parameters),
    takeLatest(acts.data_types.SAGA_RESOLVE_DOCUMENT, product.saga_resolve_document),

    // Outcomes sagas
    takeLatest(acts.outcomes_types.SAGA_SEND_QUOTEDOC, product.saga_send_quotedoc),
    takeLatest(acts.outcomes_types.SAGA_SEND_SUPPORT_AGENCY, product.saga_send_support_agency),
  ])
}
